@if (lrpEvent$ | async; as lrpEvent){
    <p-dialog [header]="'Welcome To ' + lrpEvent.name" [(visible)]="visible" [modal]="true" [style]="{ width: '60%' }" position="top" [dismissableMask]="true">
        <p>Congratulations on setting up your event.</p>
        <p>Now that we have the basics of your event set up, let's take a look at some of the next steps you should take.</p>
        <core-accordion [value]="currentStep" [linear]="false" [numbered]="false" class="mb-4">
            <core-accordion-panel header="Event Imagery" [completed]="checkExists(lrpEvent.image)">
                <p>The image you attach to your event will be the first thing that drawers your players eyes. It's also the most likely thing to draw in new players. There is a host of research into marketing trends, but the short version is people like pictures. </p>
                <p>So lets upload an image that sells your event!</p>
                <p-fileupload name="file" [headers]="getHeaders" [url]="apiUrl" (onUpload)="onUpload($event)" [multiple]="false" accept="image/*" maxFileSize="1000000" mode="advanced" [auto]="true">
                    <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback" let-uploadCallback="uploadCallback">
                        <div class="flex flex-wrap justify-between items-center flex-1 gap-4">
                            <div class="flex gap-2">
                                <button (click)="choose($event, chooseCallback)" class="primaryButton button-small">Select Image</button>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template #empty>
                        <div class="text-sm">Drag and drop files to here to upload.</div>
                    </ng-template>
                </p-fileupload>
                <div class="mb-3 mt-3">
                    <button class="primaryButton" (click)="currentStep = 1">Next</button>
                </div>
            </core-accordion-panel>
            <core-accordion-panel header="Tickets" [completed]="convertToSignal(lrpEvent.eventTickets.length > 0)">
                <p>Let's create some simple tickets for your event.</p>
                <app-new-ticket [lrpEvent]="lrpEvent" />
                <div class="mb-3 mt-3">
                    <button class="primaryButton" (click)="currentStep = 2">Next</button>
                </div>
            </core-accordion-panel>
            <core-accordion-panel header="Catering Options" [formGroup]="catererForm">
                <p>If your event is being catered you can complete the following information to help them be aware of your catering chocies.</p>
                <p>We recommend adding menu informatino as well, you'll be able to do this through the Catering page.</p>
                <div class="grid grid-cols-5 gap-2 my-3">
                    <div class="col-span-2 flex flex-col">
                        <label>Caterer</label>
                        <input type="text" id="name" formControlName="name" />
                    </div>
                    <div class="col-span-2 flex flex-col">
                        <label>Contact Details</label>
                        <input type="text" id="contact" formControlName="contact" />
                    </div>
                    <div class="flex flex-col text-center">
                        <label for="displayBookings">Display</label>
                        <label class="switch mx-auto">
                            <input type="checkbox" id="displayBookings" formControlName="display">
                            <span class="slider round"></span>
                        </label>
                    </div>
                </div>
                <p-editor formControlName="notes" class="h-40 pb-10 mb-3" />
                <button class="primaryButton button-small" [disabled]="!catererForm.valid" ><fa-icon [icon]="['fas','circle-plus']" class="me-2" />Add Catering Information</button>
                <div class="mb-3 mt-3">
                    <button class="primaryButton" (click)="currentStep = 3">Next</button>
                </div>
            </core-accordion-panel>
            <core-accordion-panel header="Other Tools">
                <p>Here are some of the other tools we make available to try and make running your event as smooth as possible.</p>
                <div class="grid grid-cols-3 gap-x-4">
                    <div class="card text-center cursor-pointer" [routerLink]="['/admin','events',lrpEvent.eventLink,'details']">
                        <fa-icon [icon]="['fas','pen-to-square']" size="2xl" class="mb-2"/>
                        Review Event Details
                    </div>
                    <div class="card text-center cusor-pointer" [routerLink]="['/admin','events',lrpEvent.eventLink,'tickets']">
                        <fa-icon [icon]="['fas','ticket']" size="2xl" class="mb-2"/>
                        Add / Edit Tickets
                    </div>
                    <div class="card text-center cursor-pointer" [routerLink]="['/admin','events',lrpEvent.eventLink,'catering']">
                        <fa-icon [icon]="['fas','burger']" size="2xl" class="mb-2"/>
                        Set Your Menu
                    </div>
                    <div class="card text-center cursor-pointer" [routerLink]="['/admin','events',lrpEvent.eventLink,'event-pack']">
                        <fa-icon [icon]="['fas','newspaper']" size="2xl" class="mb-2"/>
                        Create Event Pack
                    </div>
                    

                </div>
            </core-accordion-panel>
        </core-accordion>
    </p-dialog>
}